let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lfMTR")).then(() => parcelRequire('2Dq8O'));